import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { CustomAlertComponent } from './components/custom-alert/custom-alert.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { SharedChangePasswordComponent } from "./components/change-password/change-password.component"
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule, MatIconModule, MatCheckboxModule } from '@angular/material';
import { PasswordPolicyComponent } from './components/password-policy/password-policy.component';


@NgModule({
    declarations: [LoaderComponent,
        CustomAlertComponent,
        ConfirmComponent,
        SharedChangePasswordComponent,PasswordPolicyComponent,
    ],
  imports: [
      CommonModule,
      FormsModule, ReactiveFormsModule,
      MatFormFieldModule, MatInputModule, MatIconModule, MatCheckboxModule, 
    ],
    exports: [
        PasswordPolicyComponent,
        LoaderComponent, CustomAlertComponent,
        ConfirmComponent,
        SharedChangePasswordComponent,
        FormsModule, ReactiveFormsModule,
        MatFormFieldModule, MatInputModule, MatIconModule, MatCheckboxModule,
    ]
})
export class SharedModule { }
